import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getProfile } from '../../actions';
import _ from 'lodash';
import Spinner from '../../components/Spinner';

function withProfile(WrappedComponent) {

  class WrappingComponent extends React.Component {

    constructor(props) {
      super(props);
      this.state = {
        dataFetched: false
      };
    }

    componentDidMount() {
      this.props.getProfile(this.props.accessToken).then(
        () => {
          this.setState({dataFetched: true})
        }
      )
    }

    render() {

      // Filter out props. See: https://github.com/Pomax/
      // react-onclickoutside/issues/244#issuecomment-343461098
      const propsToFilter = [
        "accessToken",
        "getProfile"
      ];
      const filteredProps = _.pickBy(this.props, function (value, key) {
        return !(propsToFilter.indexOf(key) > -1);
      });

      return this.state.dataFetched
        ? <WrappedComponent {...filteredProps} />
        : <Spinner size={100} />
    };
  }

  function mapStateToProps(state) {
    return {
      accessToken: state.accessToken
    }
  }

  function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      getProfile
    }, dispatch)
  }

  return connect(mapStateToProps, mapDispatchToProps)(WrappingComponent)
}

export { withProfile };



// WEBPACK FOOTER //
// ./src/containers/withProfile/index.js